
export const CHESS_HOME = 'https://crypto-shots.com/chess/'; // NB. final slash or invites break!

export const SOCIALS_LINKS = {
  TWITTER: 'https://x.com/cryptoshots_nft',
  DISCORD: 'https://discord.gg/nBXHAHzcQP',
  WEBSITE: 'https://crypto-shots.com',
  HIVE_BLOG: 'https://peakd.com/@cryptoshots_nft',
  FACEBOOK: 'https://www.facebook.com/crypto4shots',
  TIKTOK: 'https://www.tiktok.com/@cryptoshots_nft',
  YOUTUBE: 'https://www.youtube.com/@cryptoshots1867/videos',
  INSTAGRAM: 'https://www.instagram.com/cryptoshots_nft',
};
// INVITES

